<template>
  <b-tabs>
    <b-tab
      title="Assinantes Webhook"
      active
    >
      <WebhookSubscribersTab :configuracoes="configuracoesWebhook" />
    </b-tab>
    <b-tab title="Configuração de API">
      <div class="text-center">
        <h4>Configuração de API</h4>
        <p>Esta seção ainda não está implementada.</p>
      </div>
    </b-tab>
  </b-tabs>
</template>

<script>
import api from './shared/services/api'

export default {
  name: 'WebhooksConfiguracao',
  components: {
    WebhookSubscribersTab: () => import('./shared/components/WebhookSubscribersTab.vue'),
  },
  data() {
    return {
      configuracoesWebhook: {},
    }
  },
  created() {
    this.carregar()
  },
  methods: {
    carregar() {
      api.getConfiguracaoWebhook()
        .then(payload => {
          this.configuracoesWebhook = payload.data || {}
        })
    },
  },
}
</script>
